import { Title } from "components/base/Title";
import { ImageBackground } from "components/ImageBackground";
import { useEffect, useState } from "react";
import { Card } from "components/base/Card";
import { Text } from "components/base/Text";
import { ConnexionContent } from "components/ConnexionContent";
import { InscriptionContent } from "components/InscriptionContent";
import { MDPOublieContent } from "components/MDPOublieContent";

type Mode = 'login' | 'register' | 'forgot-password';

export const Connexion = () => {
	const [mode, setMode] = useState<Mode>('login');

	useEffect(() => {
		const view = new URLSearchParams(window.location.search).get('view');
		if (view) {
			setMode(view as Mode);
		}
	}, []);

	return (
		<>
			<ImageBackground src="/bg-connexion.jpg" fullHeight filter="bg-secondary" opacity="opacity-40">
				<Card className={`flex flex-col ${mode === 'login' ? 'md:max-w-md' : 'md:max-w-xl'} max-w-[calc(100%-2rem)] w-full shadow-sm shadow-primary-100 gap-6 my-8`} p="px-6 py-8">
					<div className="flex flex-col">
						{mode === 'forgot-password' ? (
							<>
								<Title type='subdisplay' centered>Mot de passe oublié</Title>
								<Text centered className="text-gray-600">Réinitialisez votre mot de passe avec votre email.</Text>
							</>
						) : (
							<>
								<Title type='subdisplay' centered>{mode === 'login' ? 'Connexion' : 'Créer un compte'}</Title>
								<Text centered className="text-gray-600">Commander votre miel en direct du producteur</Text>
							</>
						)}
					</div>

					{mode === 'login' && (
						<div>
							<ConnexionContent />
							<div className="text-center mt-2">
								<button className="text-primary-600 hover:text-primary-800 hover:underline text-sm"
									onClick={() => setMode('forgot-password')}>
									Mot de passe oublié ?
								</button>
							</div>
						</div>
					)}

					{mode === 'register' && (
						<InscriptionContent />
					)}

					{mode === 'forgot-password' && (
						<MDPOublieContent />
					)}

					<div className="flex sm:flex-row flex-col justify-center items-center gap-2 w-[calc(100%+3rem)] bg-gray-200 p-4 -mx-6 -mb-8 rounded-b-2xl">
						{mode === 'forgot-password' ? (
							<button className="text-primary-600 hover:text-primary-800 hover:underline"
								onClick={() => setMode('login')}>
								Retour à la connexion
							</button>
						) : (mode === 'login' ? (
							<>
								<span>Vous n'avez pas de compte ?</span>
								<button className="text-primary-600 hover:text-primary-800 hover:underline"
									onClick={() => setMode('register')}>
									Créer un compte
								</button>
							</>
						) : (
							<>
								<span>Vous avez déjà un compte ?</span>
								<button className="text-primary-600 hover:text-primary-800 hover:underline"
									onClick={() => setMode('login')}>
									Se connecter
								</button>
							</>
						))}

					</div>

				</Card>
			</ImageBackground>
		</>
	)
}